<template>
  <div class="login-container">
    <login-form/>
  </div>
</template>

<script>
import LoginForm from '@/components/login-form.vue'

export default {
  name: 'LoginView',
  components: {
    LoginForm
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  background-image: url(~/static/5c2523aa4fdbba1f26bf1750_master.jpg);
  background-position: center center;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.view.vue